import $ from 'jquery';
import Cookies from 'js-cookie';

export function initTicketInformationBannerBlock() {
	const $ticketInformationBanner        = $('.ticketInformationBanner'),
	      cookieName                      = 'visitedTicketInformationBanners',
	      itemId                          = $ticketInformationBanner.data('itemId'),
	      visitedTicketInformationBanners = JSON.parse(Cookies.get(cookieName) || '[]');

	if (!visitedTicketInformationBanners.includes(itemId)) {
		$ticketInformationBanner.show();
	}

	$ticketInformationBanner
		.on('click', '.close', () => {
			visitedTicketInformationBanners.push(itemId);
			$('.ticketInformationBanner, .ticketInformationBannerOpenedBackground').hide();
			$('body').removeClass('ticketInformationBannerOpened');
			Cookies.set(
				cookieName,
				JSON.stringify(visitedTicketInformationBanners),
				{
					'expires': 180
				}
			);
		})
		.on('click', '.show', () => {
			$ticketInformationBanner.addClass('opened');
			$('.card-header, .show.showBtn').hide().after(() => {
				$('.ticketInformationBannerOpenedBackground').toggle();
				$('body').addClass('ticketInformationBannerOpened');
			});
		});
}